// components/Header/Header.jsx
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [busca, setBusca] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const [openBrasil, setOpenBrasil] = useState(false);
  const [openInglaterra, setOpenInglaterra] = useState(false);
  const [openPremierLeague, setOpenPremierLeague] = useState(false);
  const [openSerieA, setOpenSerieA] = useState(false);
  const [openEuropa, setOpenEuropa] = useState(false);
  const navigate = useNavigate();

  function handleBuscar(e) {
    e.preventDefault();
    if (!busca.trim()) return;
    navigate(`/buscar?q=${encodeURIComponent(busca)}`);
    setBusca("");
    setMenuOpen(false);
  }

  function closeMenu() {
    setMenuOpen(false);
  }

  function handleNavigate(path) {
    navigate(path);
    setMenuOpen(false);
    setOpenBrasil(false);
    setOpenSerieA(false);
    setOpenInglaterra(false);
    setOpenPremierLeague(false);
  }

  return (
    <header className="header">
      <div className="header-container">
        {/* LOGO */}
        <Link to="/" className="brand" onClick={() => setMenuOpen(false)}>
          <img src="/images/logo.jpg" alt="Piazada dos Mantos" />

          <div className="brand-text">
            <strong>Piazada dos Mantos</strong>
            <span>Catálogo de Camisas</span>
          </div>
        </Link>

        {/* DESKTOP NAV */}
        <nav className="desktop-nav">
          <div className="menu-item">
            <span>Brasil</span>

            <div className="dropdown level-1">
              <div className="submenu-item">
                <span>Série A</span>

                <div className="dropdown level-2">
                  <Link to="/brasil/serie-a/athletico-paranaense">
                    Athletico PR
                  </Link>
                  <Link to="/brasil/serie-a/atletico-mg">Atlético-MG</Link>
                  <Link to="/brasil/serie-a/bahia">Bahia</Link>
                  <Link to="/brasil/serie-a/botafogo">Botafogo</Link>
                  <Link to="/brasil/serie-a/bragantino">Bragantino</Link>
                  <Link to="/brasil/serie-a/corinthians">Corinthians</Link>
                  <Link to="/brasil/serie-a/coritiba">Coritiba</Link>
                  <Link to="/brasil/serie-a/cruzeiro">Cruzeiro</Link>
                  <Link to="/brasil/serie-a/flamengo">Flamengo</Link>
                  <Link to="/brasil/serie-a/fluminense">Fluminense</Link>
                  <Link to="/brasil/serie-a/gremio">Grêmio</Link>
                  <Link to="/brasil/serie-a/internacional">Internacional</Link>
                  <Link to="/brasil/serie-a/palmeiras">Palmeiras</Link>
                  <Link to="/brasil/serie-a/remo">Remo</Link>
                  <Link to="/brasil/serie-a/santos">Santos</Link>
                  <Link to="/brasil/serie-a/sao-paulo">São Paulo</Link>
                  <Link to="/brasil/serie-a/vasco">Vasco</Link>
                  <Link to="/brasil/serie-a/vitoria">Vitória</Link>
                </div>
              </div>

              {/* <div className="submenu-item">
                <span>Série B</span>
              </div> */}
            </div>
          </div>

          <div className="menu-item">
            <span>Inglaterra</span>

            <div className="dropdown level-1">
              <div className="submenu-item">
                <span>Premier League</span>

                <div className="dropdown level-2">
                  <Link to="/inglaterra/premier-league/arsenal">Arsenal</Link>
                  <Link to="/inglaterra/premier-league/aston-villa">
                    Aston Villa
                  </Link>
                  <Link to="/inglaterra/premier-league/bournemouth">
                    Bournemouth
                  </Link>
                  <Link to="/inglaterra/premier-league/brentford">
                    Brentford
                  </Link>
                  <Link to="/inglaterra/premier-league/brighton">
                    Brighton & Hove Albion
                  </Link>
                  <Link to="/inglaterra/premier-league/burnley">Burnley</Link>
                  <Link to="/inglaterra/premier-league/chelsea">Chelsea</Link>
                </div>
              </div>
            </div>
          </div>

          <div className="menu-item">
            <Link to="/selecao-brasileira" className="menu-link">
              Seleção Brasileira
            </Link>
          </div>

          <div className="menu-item">
            <Link to="/copa-do-mundo" className="menu-link">
              Copa do Mundo 2026
            </Link>
          </div>

          <div className="menu-item">
            <span>Europa</span>

            <div className="dropdown level-1">
              <Link to="/europa/barcelona">Barcelona</Link>
              <Link to="/europa/bayern-de-munique">Bayern de Munique</Link>
              <Link to="/europa/borussia-dortmund">Borussia Dortmund</Link>
              <Link to="/europa/juventus">Juventus</Link>
              <Link to="/europa/liverpool">Liverpool</Link>
              <Link to="/europa/inter-de-milao">Inter de Milão</Link>
              <Link to="/europa/manchester-city">Manchester City</Link>
              <Link to="/europa/manchester-united">Manchester United</Link>
              <Link to="/europa/milan">Milan</Link>
              <Link to="/europa/paris-saint-germain">PSG</Link>
              <Link to="/europa/real-madrid">Real Madrid</Link>
              <Link to="/europa/tottenham">Tottenham</Link>
            </div>
          </div>
          <div className="menu-item">
            <Link to="/guia-tamanhos" className="menu-link">
              Tamanhos
            </Link>
          </div>
        </nav>

        {/* SEARCH */}
        <form
          className="header-search"
          onSubmit={handleBuscar}
          style={{ position: "relative" }}
        >
          <input
            type="text"
            placeholder="Buscar time ou camisa..."
            value={busca}
            onChange={(e) => setBusca(e.target.value)}
            style={{
              paddingRight: "35px",
              border: "1px solid #1f2937",
              background: "#020617",
              color: "#fff",
              borderRadius: "20px",
              caretColor: "#22c55e",
            }}
          />

          <button
            type="submit"
            style={{
              position: "absolute",
              right: "10px",
              top: "50%",
              transform: "translateY(-50%)",
              background: "transparent",
              border: "none",
              cursor: "pointer",
              fontSize: "20px",
              color: "#fff",
              opacity: 0.8,
              transition: "transform 0.1s ease",
            }}
            onMouseDown={(e) =>
              (e.currentTarget.style.transform = "translateY(-50%) scale(0.9)")
            }
            onMouseUp={(e) =>
              (e.currentTarget.style.transform = "translateY(-50%) scale(1)")
            }
            onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
            onMouseLeave={(e) => (e.currentTarget.style.opacity = 0.8)}
          >
            🔍
          </button>
        </form>

        {/* HAMBURGER */}
        <button className="menu-toggle" onClick={() => setMenuOpen(true)}>
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="mobile-menu">
          <button className="close" onClick={closeMenu}>
            ✕
          </button>
          <strong
            className={`mobile-section ${openBrasil ? "open" : ""}`}
            onClick={() => {
              setOpenBrasil(!openBrasil);
              if (openBrasil) setOpenSerieA(false);
            }}
          >
            Brasil
          </strong>

          {openBrasil && (
            <div className="mobile-submenu">
              <div
                className={`mobile-subtitle ${openSerieA ? "open" : ""}`}
                onClick={() => setOpenSerieA(!openSerieA)}
              >
                Série A
              </div>

              {openSerieA && (
                <div className="mobile-links">
                  <span
                    onClick={() =>
                      handleNavigate("/brasil/serie-a/athletico-paranaense")
                    }
                  >
                    Athletico PR
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/brasil/serie-a/atletico-mg")
                    }
                  >
                    Atlético-MG
                  </span>
                  <span onClick={() => handleNavigate("/brasil/serie-a/bahia")}>
                    Bahia
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/botafogo")}
                  >
                    Botafogo
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/bragantino")}
                  >
                    Bragantino
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/brasil/serie-a/corinthians")
                    }
                  >
                    Corinthians
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/coritiba")}
                  >
                    Coritiba
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/cruzeiro")}
                  >
                    Cruzeiro
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/flamengo")}
                  >
                    Flamengo
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/fluminense")}
                  >
                    Fluminense
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/gremio")}
                  >
                    Grêmio
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/brasil/serie-a/internacional")
                    }
                  >
                    Internacional
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/palmeiras")}
                  >
                    Palmeiras
                  </span>
                  <span onClick={() => handleNavigate("/brasil/serie-a/remo")}>
                    Remo
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/santos")}
                  >
                    Santos
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/sao-paulo")}
                  >
                    São Paulo
                  </span>
                  <span onClick={() => handleNavigate("/brasil/serie-a/vasco")}>
                    Vasco
                  </span>
                  <span
                    onClick={() => handleNavigate("/brasil/serie-a/vitoria")}
                  >
                    Vitória
                  </span>
                </div>
              )}
            </div>
          )}

          <strong
            className={`mobile-section ${openInglaterra ? "open" : ""}`}
            onClick={() => {
              setOpenInglaterra(!openInglaterra);
              if (openInglaterra) setOpenPremierLeague(false);
            }}
          >
            Inglaterra
          </strong>

          {openInglaterra && (
            <div className="mobile-submenu">
              <div
                className={`mobile-subtitle ${openPremierLeague ? "open" : ""}`}
                onClick={() => setOpenPremierLeague(!openPremierLeague)}
              >
                Premier League
              </div>

              {openPremierLeague && (
                <div className="mobile-links">
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/arsenal")
                    }
                  >
                    Arsenal
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/aston-villa")
                    }
                  >
                    Aston Villa
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/bournemouth")
                    }
                  >
                    Bournemouth
                  </span>

                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/brentford")
                    }
                  >
                    Brentford
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/brighton")
                    }
                  >
                    Brighton & Hove Albion
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/burnley")
                    }
                  >
                    Burnley
                  </span>
                  <span
                    onClick={() =>
                      handleNavigate("/inglaterra/premier-league/chelsea")
                    }
                  >
                    Chelsea
                  </span>
                </div>
              )}
            </div>
          )}

          <div
            className="mobile-section"
            onClick={() => handleNavigate("/selecao-brasileira")}
          >
            Seleção Brasileira
          </div>

          <div
            className="mobile-section"
            onClick={() => handleNavigate("/copa-do-mundo")}
          >
            Copa do Mundo 2026
          </div>

          <strong
            className={`mobile-section ${openEuropa ? "open" : ""}`}
            onClick={() => setOpenEuropa(!openEuropa)}
          >
            Europa
          </strong>
          {openEuropa && (
            <div className="mobile-links">
              <span onClick={() => handleNavigate("/europa/barcelona")}>
                Barcelona
              </span>

              <span onClick={() => handleNavigate("/europa/bayern-de-munique")}>
                Bayern de Munique
              </span>

              <span onClick={() => handleNavigate("/europa/borussia-dortmund")}>
                Borussia Dortmund
              </span>

              <span onClick={() => handleNavigate("/europa/juventus")}>
                Juventus
              </span>

              <span onClick={() => handleNavigate("/europa/liverpool")}>
                Liverpool
              </span>

              <span onClick={() => handleNavigate("/europa/inter-de-milao")}>
                Inter de Milão
              </span>

              <span onClick={() => handleNavigate("/europa/manchester-city")}>
                Manchester City
              </span>

              <span onClick={() => handleNavigate("/europa/manchester-united")}>
                Manchester United
              </span>

              <span onClick={() => handleNavigate("/europa/milan")}>Milan</span>

              <span
                onClick={() => handleNavigate("/europa/paris-saint-germain")}
              >
                PSG
              </span>

              <span onClick={() => handleNavigate("/europa/real-madrid")}>
                Real Madrid
              </span>

              <span onClick={() => handleNavigate("/europa/tottenham")}>
                Tottenham
              </span>
            </div>
          )}

          <div
            className="mobile-section"
            onClick={() => handleNavigate("/guia-tamanhos")}
          >
            Tamanhos
          </div>

          <form
            onSubmit={handleBuscar}
            style={{ position: "relative", marginTop: "20px" }}
          >
            <input
              type="text"
              placeholder="Buscar time ou camisa..."
              value={busca}
              onChange={(e) => setBusca(e.target.value)}
              style={{
                width: "100%",
                padding: "12px 40px 12px 12px",
                borderRadius: "20px",
                border: "1px solid #1f2937",
                background: "#020617",
                color: "#fff",
                caretColor: "#22c55e",
              }}
              onFocus={(e) => (e.target.style.border = "1px solid #22c55e")}
              onBlur={(e) => (e.target.style.border = "1px solid #1f2937")}
            />

            <button
              type="submit"
              style={{
                position: "absolute",
                right: "10px",
                top: "65%",
                transform: "translateY(-50%)",
                background: "transparent",
                border: "none",
                cursor: "pointer",
                fontSize: "20px",
                color: "#fff",
                opacity: 0.8,
                transition: "transform 0.1s ease",
              }}
              onMouseDown={(e) =>
                (e.currentTarget.style.transform =
                  "translateY(-50%) scale(0.9)")
              }
              onMouseUp={(e) =>
                (e.currentTarget.style.transform = "translateY(-50%) scale(1)")
              }
            >
              🔍
            </button>
          </form>
        </div>
      )}
    </header>
  );
}
